module.exports = "pegasus_template/assets/blocks/social-2-theme6.png";